<div class="mt-5">

    <form #stakeholdersForm="ngForm">
        <div>
            <div>
                <div>
                    <div class="mb-3 g-c-primaryDarkColor font-bold">
                        <label>{{'initiative_owning_department' | translate}}</label>
                        <span class="text-red-500 font-bold">*</span>
                    </div>

                    <p-dropdown filter="true" (onChange)="entityInChargeChange()" [options]="entity_in_charg_options"
                        #entity_in_charge_id="ngModel" required optionLabel="name" [(ngModel)]="selectedInChargeUnit"
                        ngModel name="entity_in_charge_id"
                        placeholder="{{'select_initiative_owning_department' | translate}}" />
                </div>

                @if((entity_in_charge_id.invalid && entity_in_charge_id.touched)||(entity_in_charge_id.invalid
                &&isSubmitted ))
                {
                <div class="text-red-500">
                    {{'field_is_required'|translate}}
                </div>
                }

            </div>
            <div class="mt-3">
                <div>
                    <div class="mb-3 g-c-primaryDarkColor font-bold">
                        <label>{{'implementation_lead' | translate}}</label>
                        <span class="text-red-500 font-bold">*</span>
                    </div>
                    <p-dropdown filter="true" optionValue="value" [options]="filteredEmployees"
                        #executive_in_charge_id="ngModel" required optionLabel="name"
                        [(ngModel)]="stakeholderModel.executive_in_charge_id" ngModel name="executive_in_charge_id"
                        placeholder="{{'select_implementation_lead' | translate }}" />
                </div>
                @if((executive_in_charge_id.invalid&&
                executive_in_charge_id.touched)||(executive_in_charge_id.invalid&&isSubmitted ))
                {
                <div class="text-red-500">
                    {{'field_is_required'|translate}}
                </div>
                }

            </div>
            <div class="mt-3">
                <div>
                    <div class="mb-3 g-c-primaryDarkColor font-bold">
                        <label>{{'supporting_departments' | translate}}</label>
                        <span class="text-red-500 font-bold">*</span>
                    </div>

                    <p-multiSelect display="chip" placeholder="{{'supporting_departments' | translate}}"
                        #supporting_units="ngModel" required [(ngModel)]="stakeholderModel.supporting_units" name="supporting_units"
                        [options]="supporting_units_options" optionValue="value" optionLabel="name" />
                </div>
                @if((supporting_units.invalid && supporting_units.touched)||(supporting_units.invalid && isSubmitted))
                {
                <div class="text-red-500">
                    {{'field_is_required'|translate}}
                </div>
                }
            </div>
        </div>
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'supporting_leads' | translate }}</label>
            </div>
            <textarea #support_in_charge="ngModel" placeholder="{{'supporting_leads' | translate }}"
                [(ngModel)]="stakeholderModel.support_in_charge" ngModel name="support_in_charge" rows="3" cols="30"
                pInputTextarea></textarea>
        </div>
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'partners' | translate }}</label>
            </div>
            <textarea #supporters="ngModel" placeholder="الداعمين" [(ngModel)]="stakeholderModel.supporters" ngModel
                name="supporters" rows="3" cols="30" pInputTextarea></textarea>
        </div>
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'partners_link_description' | translate }}</label>
            </div>
            <textarea #partners_link_description="ngModel"
                placeholder="{{'partners_link_description' | translate }}"
                [(ngModel)]="stakeholderModel.partners_link_description" ngModel name="partners_link_description" rows="3"
                cols="30" pInputTextarea></textarea>
        </div>
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'supporters' | translate }}</label>
            </div>
            <textarea #partners="ngModel" placeholder="{{'partners_supporters' | translate }}"
                [(ngModel)]="stakeholderModel.partners" ngModel name="partners" rows="3" cols="30" pInputTextarea></textarea>
        </div>
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'supporters_link_description' | translate }}</label>
            </div>
            <textarea #supporters_link_description="ngModel" placeholder="وصف ارتباط الداعمين"
                [(ngModel)]="stakeholderModel.supporters_link_description" ngModel name="supporters_link_description"
                rows="3" cols="30" pInputTextarea></textarea>
        </div>
    </form>
</div>